export const LAUNCH_CALL_URL = "https://meetings.hubspot.com/alli-ai";

export const WELCOME_VIDEO_URL =
  "https://www.alliai.com/wp-content/uploads/2026/10/autopto_login_screen_min-_final.mp4";

// The Autopto trial length, for the moment between signup and the Stripe
// webhook that fills `trial_end_at`.
export const TRIAL_FALLBACK_DAYS = 7;

// Kyle's video on the upsell page (ClickUp 86e3wqp3j).
export const UPSELL_VIDEO_URL =
  "https://www.alliai.com/wp-content/uploads/2026/11/upsell_vid.mp4";
